import React, { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import axiosCAPApiPrivate from "../../api/axiosCAPApiPrivate";

export const TrackingModal = ({ isOpen, onClose, trackingNumbers, productType, shipperAccountNo }) => {
    const [sendTipidTrackingNo, setSendTipidTrackingNo] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [isToastOpen, setToastOpen] = React.useState(false);
    const [toastKind, setToastKind] = React.useState("");
    const [toastTitle, setToastTitle] = React.useState("");
    const [toastDesc, setToastDesc] = React.useState("");
    // trackingNumbers should already be grouped by 2 per row
    // Example: [["ST-1", "ST-2"], ["ST-3", "ST-4"]]
    const rows = trackingNumbers?.length ? trackingNumbers : [];

    React.useEffect(() => {
        if (isOpen && productType && shipperAccountNo) {
            getTrackingNoByProductTypeId(productType, shipperAccountNo);
        }
    }, [isOpen, productType, shipperAccountNo]);

    const getTrackingNoByProductTypeId = async (productType, shipperAccountNo) => {
        setSendTipidTrackingNo([]);
        setLoading(true);

        const reqData = {
            ProductTypeId: productType,
            ShipperAccountNo: shipperAccountNo
        };

        try {
            const response = await axiosCAPApiPrivate.post(
                "/api/SendTipidCheckTrackingNoIsUsed",
                reqData
            );

            const resData = response.data;
            if (resData.Code === "200") {
                console.log("Tracking Data:", resData.Data);
                setSendTipidTrackingNo(resData.Data);
            }
        } catch (error) {
            setToastKind("error");
            setToastTitle("API Fetch Failed!");
            setToastDesc(error.message);
            setToastOpen(true);
            setTimeout(() => setToastOpen(false), 5000);
        } finally {
            setLoading(false);
        }
    };

    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 z-50 overflow-auto" onClose={onClose}>
                <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 40 }} aria-hidden="true" />
                <div className="flex min-h-screen items-center justify-center p-4">
                    <Transition.Child
                        as="div"
                        enter="transition ease duration-300 transform"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease duration-300 transform"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                        className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full z-50"
                    >
                        <Dialog.Panel>
                            <Dialog.Title className="text-2xl font-bold text-center mb-4">
                                Product’s Tracking Number
                            </Dialog.Title>

                            {loading ? (
                                <p className="text-center text-gray-500">Loading...</p>
                            ) : sendTipidTrackingNo.length === 0 ? (
                                <p className="text-center text-gray-500">No tracking numbers available.</p>
                            ) : (
                                <div className="overflow-x-auto">
                                    <table className="min-w-full border border-gray-300 rounded">
                                        <tbody>
                                            {chunkArray(sendTipidTrackingNo, 2).map((row, rowIndex) => ( // 2 per row
                                            <tr key={rowIndex}>
                                                {row.map((item, cellIndex) => (
                                                <td
                                                    key={cellIndex}
                                                    className="border border-gray-300 px-4 py-2 text-center text-sm font-bold"
                                                >
                                                    <span
                                                    style={{
                                                        color: item.IsUsed ? "green" : "orange",
                                                        backgroundColor: "transparent",
                                                    }}
                                                    >
                                                    {item.TrackingNo || "-"}
                                                    </span>
                                                </td>
                                                ))}
                                                {/* Kung kulang ng isa para maging 2 cells per row */}
                                                {row.length < 2 &&
                                                [...Array(2 - row.length)].map((_, idx) => (
                                                    <td
                                                    key={`empty-${idx}`}
                                                    className="border border-gray-300 px-4 py-2 text-center text-sm"
                                                    >
                                                    -
                                                    </td>
                                                ))}
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
};
